// account
export const ACCOUNT = "999";
export const NUMBER_ACCOUNT = 999;
// time
export const NO_TIME = "--:--";

// ENERSI ENVIRONMENT

export const ENERSI_ENV = process.env.REACT_APP_ENERSI_ENV?.trim().toUpperCase() || 'LOCAL'
export const ENERSI_SERVER = process.env.REACT_APP_ENERSI_SERVER || 'Lx0B'
export const IS_PROD = ENERSI_ENV === 'PROD'
export const IS_CRM = ENERSI_ENV === 'CRM'
export const ENERSI_VERSION = process.env.REACT_APP_ENERSI_VERSION || "LOCAL.0.0.0";
export const ENERSI_CONF = process.env.REACT_APP_ENERSI_CONF || "local";
